import React, { useEffect, useMemo, useState } from "react";
import Carousel from "react-material-ui-carousel";
import { Box, Stack } from "@mui/material";

import UpcomingCard from "../reservation/UpcomingCard";
import { useResponsive } from "../../hooks/useResponsive";
import { isMobileDeviceCheck } from "../../utils";

const CarouselWithIndicator = ({
  data,
  gateList,
  onClickGate,
  onPress,
  onPressPayNow,
}) => {
  const smDown = useResponsive("down", "sm");
  const desktopSliderItems = data?.length > 3 ? 3 : data?.length || 0;
  const noOfItems = smDown ? 1 : desktopSliderItems;
  const [carouselTimer, setCarouselTimer] = useState(false);
  const sliderItems = useMemo(() => {
    const items = [];
    for (let i = 0; i < data?.length; i += noOfItems) {
      if (i % noOfItems === 0) {
        items.push(
          <Stack spacing={1} direction={"row"} p={"5px 10px"} key={i}>
            {data.slice(i, i + noOfItems).map((item, index) => (
              <UpcomingCard
                key={index}
                data={item}
                gateList={gateList}
                onPress={(gates) => {
                  onPress && onPress(item, gates);
                }}
                onPressPayNow={(gates) => {
                  onPressPayNow && onPressPayNow(item, gates);
                }}
                openGate={(gate) => {
                  onClickGate && onClickGate(item, gate);
                }}
              />
            ))}
          </Stack>,
        );
      }
    }
    return items;
  }, [data, noOfItems, onClickGate, onPress, gateList]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCarouselTimer(true);
    }, 1000);
  }, []);

  if (!sliderItems?.length) {
    return null; // No items to display
  }

  return (
    <Box position="relative">
      {carouselTimer && (
        <Carousel
          animation="slide"
          autoPlay={false}
          indicators={true}
          className="carousel"
          navButtonsAlwaysVisible={false}
          navButtonsAlwaysInvisible={false}
        >
          {sliderItems}
        </Carousel>
      )}
    </Box>
  );
};

export default CarouselWithIndicator;
